<template>
    <v-row no-gutters class="py-1">
        <v-col cols="12" class="pl-2 py-0 mb-0" v-if="saveable">
            <v-switch
                v-model="saveProduct"
                label="Enregistrer le produit"
                class="py-0 mb-0"
                data-cy="createInvoiceProduct-saveProduct"
            />
        </v-col>
        <v-col cols="12" class="pb-4">
            <FreeTag
                :invoiceProduct="product"
                :companyTags="allCompanyTags"
                :company="selectedCompany"
                :createIfMissing="true"
                :multiple="false"
                @onTagsChanged="onTagsChanged"
            >
            </FreeTag>
        </v-col>
        <v-col cols="7" class="pr-1">
            <v-text-field-filled
                outlined
                v-model="product.title"
                label="Nom du produit"
                dense
                data-cy="CreateInvoiceProduct-nom"
            />
        </v-col>
        <v-col cols="5" class="pl-1">
            <v-text-field-filled
                v-model="product.reference"
                label="Référence du produit"
                data-cy="CreateInvoiceProduct-reference"
                :error-messages="productReferenceRules"
            />
        </v-col>
        <v-col cols="12" class="d-flex flex-row mt-3">
            <v-tabs
                v-model="activeTab"
                direction="vertical"
                center-active
                style="
                    background-color: transparent !important;
                    border-radius: 16px;
                    overflow: hidden;
                "
                id="Stock"
            >
                <v-tab value="Description" data-cy="invoices-description-tab"> Description </v-tab>
                <v-tab value="Stock" :disabled="!enableStock" data-cy="invoices-stock-tab">
                    Stock
                </v-tab>
            </v-tabs>
            <v-tabs-window
                v-model="activeTab"
                style="background-color: transparent !important"
                class="flex-grow-1"
            >
                <v-tabs-window-item value="Description">
                    <v-row no-gutters class="py-1 w-100">
                        <v-col
                            cols="12"
                            v-if="
                                !enableStock && salesAccountableAccounts.length > 1 && !isDiscount
                            "
                        >
                            <v-select-filled
                                v-model="accountableAccountSelected"
                                :items="salesAccountableAccounts"
                                label="Compte comptable du produit"
                                item-title="description"
                                item-value="id"
                                data-cy="createInvoiceProduct-accountableAccount"
                            />
                        </v-col>
                        <v-col cols="12" class="pt-2" v-if="vatSubject">
                            <v-select-filled
                                v-model="product.vatRate"
                                :items="vatList"
                                :menu-props="{ auto: true }"
                                label="Taux de TVA"
                                data-cy="createInvoiceProduct-vatRate"
                                hide-details
                            />
                        </v-col>
                        <v-col cols="12">
                            <!-- <v-radio-group
                                v-model="amountType"
                                inline
                                v-if="isDiscount"
                                color="primary"
                            >
                                <v-radio label="Prix unitaire" value="unitPrice" />
                                <v-radio
                                    label="Pourcentage"
                                    value="percentage"
                                    data-cy="createInvoiceProduct-percentage-radio"
                                />
                            </v-radio-group> -->
                            <oss-text-field-filled
                                class="pt-2"
                                outlined
                                :suffix="amountType === 'percentage' ? '%' : '&#x20ac;'"
                                :label="
                                    amountType === 'percentage'
                                        ? 'Pourcentage de la remise'
                                        : 'Prix unitaire'
                                "
                                dense
                                data-cy="createInvoiceProduct-unitPrice-radio"
                                hide-details
                                v-model="amount"
                            />
                            <v-textarea-filled
                                class="pt-2"
                                auto-grow
                                label="Description"
                                v-model="product.description"
                            />
                        </v-col>
                        <v-col cols="12" class="d-flex justify-end" v-if="!saveable && !actions">
                            <v-btn
                                elevation="0"
                                size="small"
                                @click="save()"
                                :disabled="disabledSave()"
                                :loading="saveLoading"
                                data-cy="createInvoiceProduct-upsert"
                                >{{ !id ? "Créer le produit" : "Modifier le produit" }}</v-btn
                            >
                        </v-col>
                    </v-row>
                </v-tabs-window-item>
                <v-tabs-window-item value="Stock">
                    <v-window
                        v-model="wizardStep"
                        class="elevation-0"
                        style="background: transparent"
                    >
                        <v-window-item :value="0">
                            <v-row no-gutters class="py-1">
                                <v-col cols="12" class="pb-3">
                                    <v-select-filled
                                        v-model="product.type"
                                        :items="stockProductTypes"
                                        label="Type"
                                        item-title="description"
                                        item-value="type"
                                        data-cy="createStockProduct-accountableAccount"
                                        @update:model-value="accountableAccountSelected = ''"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="12" class="pb-3" v-if="product.type === 'EXPENSE'">
                                    <v-select-filled
                                        v-model="accountableAccountSelected"
                                        :items="expenseAccountableAccounts"
                                        label="Compte de charge"
                                        item-title="description"
                                        item-value="id"
                                        data-cy="createStockProduct-accountableAccount"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="10" class="pb-3" v-else>
                                    <v-select-filled
                                        v-model="accountableAccountSelected"
                                        :items="salesAccountableAccounts"
                                        label="Compte de variation de stocks"
                                        item-title="description"
                                        item-value="id"
                                        :readonly="product.type === 'EXPENSE'"
                                        data-cy="createStockProduct-inventoryAccountableAccount"
                                        hide-details
                                    />
                                </v-col>
                                <v-col cols="2" class="pb-3" v-if="product.type === 'PRODUCT'">
                                    <v-btn
                                        elevation="0"
                                        class="ml-4"
                                        color="primary"
                                        @click="wizardStep = 2"
                                    >
                                        B O M
                                    </v-btn>
                                </v-col>
                                <v-col cols="12" class="pb-3" v-if="product.type === 'EXPENSE'">
                                    <v-text-field-filled
                                        v-model="selectedThirdPartyCompany.name"
                                        readonly
                                        label="Fournisseur"
                                        data-cy="createStockProduct-thirdPartyCompany"
                                        hide-details
                                        @click="wizardStep++"
                                    />
                                </v-col>
                                <template v-for="(subproduct, index) in subproductLines">
                                    <v-col cols="3" class="pt-1">
                                        <v-select-filled
                                            v-model="subproduct.quantityType"
                                            :items="quantityTypes"
                                            item-title="text"
                                            item-value="value"
                                            :menu-props="{ auto: true }"
                                            label="Grandeur"
                                            data-cy="createInvoiceProduct-quantityType"
                                            hide-details
                                        />
                                    </v-col>
                                    <v-col cols="2" class="pt-1 pl-2">
                                        <oss-text-field-filled
                                            outlined
                                            :label="getUnitOfMeasureLabel(subproduct.quantityType)"
                                            content-class="oss-dark pl-2"
                                            dense
                                            data-cy="createInvoiceProduct-unitOfMesure"
                                            hide-details
                                            v-model="subproduct.unitQuantity"
                                        />
                                    </v-col>
                                    <v-col cols="2" class="pt-1 pl-2">
                                        <v-text-field-filled
                                            :model-value="getSymbolData(subproduct).text"
                                            label="Affichage"
                                            data-cy="createInvoiceProduct-display"
                                            readonly
                                            hide-details
                                        />
                                    </v-col>
                                    <v-col cols="4" pt-1 class="pt-1 pl-2">
                                        <v-text-field-filled
                                            v-model="subproduct.quantityName"
                                            label="Nom"
                                            data-cy="createInvoiceProduct-quantityName"
                                            hide-details="auto"
                                        />
                                    </v-col>
                                    <v-col
                                        cols="1"
                                        class="align-content-center align-center justify-center pt-1 px-1"
                                    >
                                        <v-row
                                            no-gutters
                                            class="d-flex flex-row justify-center align-center"
                                        >
                                            <v-col cols="5" class="my-auto">
                                                <v-btn-icon
                                                    icon="$add"
                                                    v-if="subproductEnabled(index, true)"
                                                    density="comfortable"
                                                    elevation="0"
                                                    color="primary"
                                                    @click="
                                                        subproductLines.push({
                                                            ...defaultSubproduct,
                                                        })
                                                    "
                                                />
                                            </v-col>
                                            <v-col cols="5">
                                                <v-btn-trash
                                                    v-if="subproductEnabled(index, false)"
                                                    density="comfortable"
                                                    @click="deleteSubproduct(index)"
                                                />
                                            </v-col>
                                        </v-row>
                                    </v-col>
                                </template>
                            </v-row>
                        </v-window-item>
                        <v-window-item :value="1">
                            <v-row no-gutters>
                                <v-col cols="1">
                                    <v-btn-back size="small" @click.stop="wizardStep = 0" />
                                </v-col>
                            </v-row>
                            <CompaniesTable
                                :parentCompanyId="companyId"
                                :showGenericCompany="product.type === 'EXPENSE'"
                                :showCustomerCompanies="product.type === 'PRODUCT'"
                                :showSupplierCompanies="product.type === 'EXPENSE'"
                                :showExistingCompanies="false"
                                @select-company="setThirdParty($event)"
                            />
                        </v-window-item>
                        <v-window-item :value="2">
                            <v-row no-gutters>
                                <v-btn-back size="small" @click.stop="wizardStep = 0" />
                                <v-data-table
                                    :headers="bomHeaders"
                                    :items="bomLines"
                                    class="table strong-border"
                                    fixed-header
                                    max-height="60vh"
                                    :multi-sort="false"
                                    :no-data-text="'Aucun produit ajouté'"
                                    hide-default-footer
                                >
                                    <template v-slot:item="{ item, index }">
                                        <tr data-cy="stockProduct-bom">
                                            <td class="align-center">
                                                <v-select-filled
                                                    v-model="item.tagId"
                                                    :items="productTags"
                                                    item-title="name"
                                                    item-value="id"
                                                    :hide-details="true"
                                                    class="v-select-font-size"
                                                    data-cy="bom-product"
                                                />
                                            </td>
                                            <td class="align-center">
                                                <oss-text-field-filled
                                                    dense
                                                    filled
                                                    :hide-details="true"
                                                    outlined
                                                    class="ml-2 righted-input"
                                                    v-model="item.quantity"
                                                >
                                                </oss-text-field-filled>
                                            </td>
                                            <td class="text-center pl-3 pb-2">
                                                <v-btn-trash
                                                    size="small"
                                                    @click="bomLines.splice(index, 1)"
                                                />
                                            </td>
                                        </tr>
                                    </template>

                                    <template v-slot:body.append>
                                        <tr class="mx-2">
                                            <td class="align-center">
                                                <v-select-filled
                                                    v-model="newItem.tagId"
                                                    :items="productTags"
                                                    item-title="name"
                                                    item-value="id"
                                                    :hide-details="true"
                                                    class="v-select-font-size"
                                                    data-cy="bom-product"
                                                />
                                            </td>
                                            <td class="align-center">
                                                <oss-text-field-filled
                                                    dense
                                                    filled
                                                    :hide-details="true"
                                                    outlined
                                                    class="ml-2 righted-input"
                                                    v-model="newItem.quantity"
                                                >
                                                </oss-text-field-filled>
                                            </td>
                                            <td class="text-center pl-3 pb-2">
                                                <v-btn-icon
                                                    icon="$add"
                                                    size="small"
                                                    @click="addItem()"
                                                    :disabled="disabledAdd"
                                                    elevation="0"
                                                    color="secondary"
                                                />
                                            </td>
                                        </tr>
                                    </template>
                                </v-data-table>
                            </v-row>
                        </v-window-item>
                    </v-window>
                </v-tabs-window-item>
            </v-tabs-window>
        </v-col>
    </v-row>
</template>

<script lang="ts">
import gql from "graphql-tag";
import { Apollo } from "@/decorators";

import CompaniesTable from "../admin/CompaniesTable.vue";
import FreeTag from "../tag/FreeTag.vue";
import { CreateProduct } from "./CreateProduct";

import INVOICE_PRODUCT from "@/graphql/invoice/InvoiceProduct.gql";
import REVENUE_ACCOUNTABLE_ACCOUNTS_QUERY from "@/graphql/accountableAccount/RevenueAccountableAccounts.gql";
import { filterAccountableAccounts } from "../../../../backend/src/common/accountableAccount/accountableAccountServices";

import { Component, Prop, Watch, toNative } from "vue-facing-decorator";

@Component({
    components: {
        CompaniesTable,
        FreeTag,
    },
    emits: ["product-created", "product-saved", "product"],
})
export class CreateInvoiceProduct extends CreateProduct {
    @Prop({ default: false }) stock: boolean;
    @Prop({ default: true }) saveable: boolean;
    @Prop({ default: true }) vatSubject: boolean;

    accountableAccountSelected = "";

    wizardStep = 0;
    activeTab = "Description";

    saveProduct = true;
    saveLoading: boolean = false;

    familySearch = "";

    defaultProduct = {
        id: "",
        title: "",
        reference: "",
        description: "",
        unitPrice: 0.0,
        vatRate: 0,
        percentage: 0,
        accountableAccount: {
            id: "",
            name: "",
        },
        type: "PRODUCT",
        tag: null,
    };

    productReferenceRules = [];

    //STOCKS
    selectedThirdPartyCompany = {
        name: "",
        id: "",
    };

    defaultSelectedThirdPartyCompany = {
        name: "",
        id: "",
    };

    stockProductTypes = [
        { type: "PRODUCT", description: "Produit" },
        { type: "EXPENSE", description: "Achat" },
    ];

    bomHeaders = [
        { title: "Famille", value: "family", sortable: true },
        { title: "Quantité de produit", value: "available", sortable: true, align: "center" },
        { title: "Actions", value: "actions", sortable: false, align: "center" },
    ];

    bomLines = [];
    subproductLines = [
        {
            quantityName: "",
            quantityType: "QUANTITY",
            unitQuantity: 1,
        },
    ];

    defaultSubproduct = {
        quantityName: "",
        quantityType: "QUANTITY",
        unitQuantity: 1,
    };

    defaultItem = {
        family: "",
        tagId: null,
        quantity: null,
    };

    newItem = {
        family: "",
        tagId: null,
        quantity: null,
    };

    //INVOICE

    amountType: "percentage" | "unitPrice" = "unitPrice";

    vatList = [
        { value: 20, title: "20" },
        { value: 10, title: "10" },
        { value: 8.5, title: "8.5" }, // TAUX TVA 8.5 Done
        { value: 5.5, title: "5.5" },
        { value: 2.1, title: "2.1" },
        { value: 0, title: "0" },
    ];

    get selectedCompany() {
        return this.$store.getters.getCompany(this.companyId);
    }

    get activateTagguing() {
        // if(this.enableStock) {
        //     return false
        // }
        return true;
    }

    get amount() {
        if (!this.enableStock && this.isDiscount) {
            return this.amountType === "percentage"
                ? this.product.percentage
                : this.product.unitPrice;
        }
        return this.product.unitPrice;
    }

    set amount(value) {
        if (!this.enableStock && this.amountType === "percentage") {
            this.product.percentage = value;
            this.product.unitPrice = null;
        } else {
            this.product.unitPrice = value;
            this.product.percentage = null;
        }
    }

    get disabledAdd() {
        if (this.newItem.tagId && this.newItem.quantity) {
            return false;
        }
        return true;
    }

    get isDiscount() {
        return (
            this.product?.accountableAccount?.name && this.product.accountableAccount.name === "709"
        );
    }

    get enableStock() {
        return this.selectedCompany?.profile?.stock;
    }

    get expenseAccountableAccounts() {
        const includeRootAAs = [
            "601000",
            "601005",
            "601010",
            "601020",
            "601100",
            "601130",
            "601700",
            "602100",
            "602200",
            "602210",
            "602220",
            "602230",
            "602240",
            "602250",
            "602600",
            "602610",
            "602650",
            "602670",
            "607000",
            "607030",
            "607100",
            "607200",
        ];
        return filterAccountableAccounts(
            this.$store.state.accountableAccountTable,
            includeRootAAs,
            [],
        );
    }

    beforeMount() {
        if (this.actions) {
            this.actions.action.title = () => {
                return !this.id ? "Créer le produit" : "Modifier le produit";
            };
            this.actions.action.disabled = this.disabledSave;
            this.actions.action.function = this.save;
            this.actions.action.loading = () => {
                return this.saveLoading;
            };
        }
    }

    @Apollo({
        query() {
            return REVENUE_ACCOUNTABLE_ACCOUNTS_QUERY;
        },
        variables() {
            return {
                companyId: this.companyId,
                vatRate0: false,
            };
        },
        // debounce: 500,
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.companySalesAccounts && data.companySalesAccounts.salesAccounts) {
                    const sAA = data.companySalesAccounts.salesAccounts;
                    if (this.enableStock) {
                        this.salesAccountableAccounts = sAA.filter((sa) => sa.name !== "707");
                    } else {
                        this.salesAccountableAccounts = sAA;
                    }
                    if (!this.accountableAccountSelected) {
                        this.accountableAccountSelected = this.salesAccountableAccounts?.[0]?.id;
                    }
                }
            }
        },
    })
    salesAccountableAccounts: Array<any> = [];

    @Apollo({
        query: gql`
            query ProductsReferenceNumber($ref: String, $id: ID!, $currentProductId: ID) {
                invoiceProductsConnection(
                    where: { reference: $ref, company: { id: $id }, id_not: $currentProductId }
                ) {
                    aggregate {
                        count
                    }
                }
            }
        `,
        variables() {
            return {
                ref: this.product.reference,
                id: this.companyId,
                currentProductId: this.product.id,
            };
        },
        skip() {
            return this.product.reference === "";
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingRefVerification = loading;
            if (!loading) {
                if (
                    data &&
                    data.invoiceProductsConnection &&
                    data.invoiceProductsConnection.aggregate
                ) {
                    this.refExist = data.invoiceProductsConnection.aggregate.count !== 0;
                }
            }
        },
    })
    refExist = false;

    loadingRefVerification = false;

    @Apollo({
        query() {
            return /*this.stock ? STOCK_PRODUCT : */ INVOICE_PRODUCT;
        },
        variables() {
            return {
                id: this.id,
            };
        },
        // debounce: 500,
        fetchPolicy: "network-only",
        skip() {
            return !this.id;
        },
        specificResult({ data, loading, networkStatus }: any) {
            this.loadingDocument = loading;
            if (!loading) {
                if (data && data.invoiceProduct) {
                    if (this.enableStock) {
                        this.subproductLines[0].quantityType =
                            data.invoiceProduct.quantityType || "QUANTITY";
                        this.subproductLines[0].quantityName =
                            data.invoiceProduct.quantityName || null;
                        this.subproductLines[0].unitQuantity =
                            data.invoiceProduct.unitQuantity || 1;
                        if (data.invoiceProduct.data?.quantities?.length) {
                            this.subproductLines.push(...data.invoiceProduct.data.quantities);
                        }
                        if (data.invoiceProduct.thirdPartyCompany) {
                            this.selectedThirdPartyCompany = data.invoiceProduct.thirdPartyCompany;
                        }
                        if (data.invoiceProduct.data?.bom) {
                            for (const bomItem of data.invoiceProduct.data.bom) {
                                if (!bomItem.tagId) {
                                    bomItem.tagId = null;
                                }
                            }
                            this.bomLines = data.invoiceProduct.data.bom;
                        }
                    }
                    this.product = data.invoiceProduct;
                    if (this.product.accountableAccount) {
                        this.accountableAccountSelected = this.product.accountableAccount.id;
                    }
                    if (this.isDiscount) {
                        if (this.product.percentage) {
                            this.amountType = "percentage";
                        }
                    }
                } else {
                    this.resetProduct();
                }
            }
        },
    })
    product = {
        id: "",
        title: "",
        reference: "",
        description: "",
        unitPrice: 0.0,
        vatRate: 0,
        percentage: 0,
        accountableAccount: {
            id: "",
            name: "",
        },
        type: "PRODUCT",
        tag: null,
        quantityType: "QUANTITY",
        unitQuantity: 1,
        quantityName: null,
    };

    @Apollo({
        query: gql`
            query ProductTags($companyId: ID!) {
                #$type: InvoiceProductType!,
                tags(where: { company: { id: $companyId }, invoiceProducts_some: { id_not: "" } }) {
                    id
                    name
                }
            }
        `,
        variables() {
            return {
                companyId: this.companyId,
            };
        },
        skip() {
            return !this.companyId || !this.enableStock;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (data.tags.length) {
                this.productTags = data.tags;
            } else {
                this.productTags = [];
            }
        },
    })
    productTags = [];

    subproductEnabled(index, action) {
        // action === true : add
        const i = index + 1;
        const length = this.subproductLines.length;
        if (action) {
            if (index === 0 && length === 1) {
                return true;
            }
            if (i === length /* && i < 5 */) {
                if (
                    this.subproductLines[index].quantityName &&
                    this.subproductLines[index].unitQuantity
                ) {
                    return true;
                }
                return false;
            }
        } else {
            if (i === length || i > 1) {
                return true;
            }
        }

        return false;
    }

    deleteSubproduct(index) {
        this.subproductLines.splice(index, 1);
    }

    resetProduct() {
        this.product = JSON.parse(JSON.stringify(this.defaultProduct));
        this.accountableAccountSelected = "";
        if (this.enableStock) {
            this.wizardStep = 0;
            this.bomLines.length = 0;
            this.subproductLines = [{ ...this.defaultSubproduct }];
            this.newItem = JSON.parse(JSON.stringify(this.defaultItem));
            this.selectedThirdPartyCompany = JSON.parse(
                JSON.stringify(this.defaultSelectedThirdPartyCompany),
            );
        }
    }

    async createProduct() {
        if (this.saveProduct) {
            await this.save(true);
        }
        this.$emit("product-created", this.product);
        this.resetProduct();
    }

    addItem() {
        // debugger
        this.bomLines.push({
            quantity: this.newItem.quantity,
            tagId: this.newItem.tagId,
            family: this.newItem.family,
        });
        this.newItem = JSON.parse(JSON.stringify(this.defaultItem));
    }

    validSubproducts() {
        for (const [index, subproduct] of this.subproductLines.entries()) {
            if (index === 0) {
                continue;
            }
            if (!subproduct.quantityName || !subproduct.unitQuantity) {
                return false;
            }
        }
        return true;
    }

    disabledSave() {
        if (!this.product.title) return true;
        if (!this.product.reference) return true;
        if (!this.product.unitPrice && !this.product.percentage) return true;
        if (this.enableStock) {
            if (!this.validSubproducts()) return true;
            if (!this.accountableAccountSelected) return true;
            if (this.productReferenceRules.length) return true;
        }
        return false;
    }

    setThirdParty(company) {
        this.selectedThirdPartyCompany.name = company.name;
        this.selectedThirdPartyCompany.id = company.id;
        this.wizardStep--;
    }

    async save(returnBeforeReset = false) {
        this.saveLoading = true;
        let accountableAccount = undefined;
        let thirdPartyCompany = undefined;
        if (this.accountableAccountSelected) {
            accountableAccount = { connect: { id: this.accountableAccountSelected } };
        } else if (this.salesAccountableAccounts.length && !this.enableStock) {
            // INVOICE
            accountableAccount = { connect: { id: this.salesAccountableAccounts[0].id } };
        }
        if (this.selectedThirdPartyCompany.id) {
            thirdPartyCompany = { connect: { id: this.selectedThirdPartyCompany.id } };
        }
        let data;
        if (!data) {
            data = {};
        }
        if (this.bomLines.length) {
            data.bom = this.bomLines;
        }
        if (this.subproductLines.length > 1) {
            data.quantities = this.subproductLines.slice(1, this.subproductLines.length);
        }
        const tagCreate = this.tag?.id ? { connect: { id: this.tag.id } } : undefined;
        const tagUpdate = this.tag?.id
            ? { connect: { id: this.tag.id } }
            : this.product.tag?.id
              ? { disconnect: true }
              : undefined;

        let invoiceProductVariables: any = {
            id: this.product.id,
            companyId: this.companyId,
            stock: this.stock,
            reference: this.product.reference,
            title: this.product.title,
            description: this.product.description,
            vatRate: this.vatSubject ? this.product.vatRate : 0,
            unitPrice: this.product.unitPrice,
            accountableAccountCreate: accountableAccount,
            accountableAccountUpdate: accountableAccount,
            quantityType: this.subproductLines[0].quantityType || undefined,
            unitQuantity: this.subproductLines[0].unitQuantity || undefined,
            quantityName:
                this.subproductLines[0].quantityType === "QUANTITY"
                    ? this.subproductLines[0].quantityName
                    : null,
            tagCreate,
            tagUpdate,
        };

        if (this.enableStock) {
            invoiceProductVariables = {
                ...invoiceProductVariables,
                type: this.product.type,
                data,
                thirdPartyCompanyCreate: thirdPartyCompany,
                thirdPartyCompanyUpdate: thirdPartyCompany,
            };
        } else {
            invoiceProductVariables = {
                ...invoiceProductVariables,
                type: "PRODUCT",
                percentage: this.product.percentage,
            };
        }

        debugger;

        const result = await this.$apollo.mutate({
            mutation: gql`
                mutation upsertInvoiceProduct(
                    $id: ID!
                    $companyId: ID!
                    $stock: Boolean!
                    $reference: String!
                    $title: String!
                    $unitPrice: Float
                    $type: InvoiceProductType
                    $accountableAccountCreate: AccountableAccountCreateOneInput
                    $accountableAccountUpdate: AccountableAccountUpdateOneInput
                    $tagCreate: TagCreateOneInput
                    $tagUpdate: TagUpdateOneInput
                    $percentage: Float
                    $vatRate: Float
                    $description: String
                    $thirdPartyCompanyCreate: CompanyCreateOneInput
                    $thirdPartyCompanyUpdate: CompanyUpdateOneInput
                    $data: Json
                    $quantityType: InvoiceProductQuantityType
                    $unitQuantity: Float
                    $quantityName: String
                ) {
                    upsertInvoiceProduct(
                        where: { id: $id }
                        create: {
                            company: { connect: { id: $companyId } }
                            reference: $reference
                            title: $title
                            percentage: $percentage
                            unitPrice: $unitPrice
                            vatRate: $vatRate
                            type: $type
                            accountableAccount: $accountableAccountCreate
                            stock: $stock
                            thirdPartyCompany: $thirdPartyCompanyCreate
                            data: $data
                            tag: $tagCreate
                            quantityType: $quantityType
                            unitQuantity: $unitQuantity
                            quantityName: $quantityName
                            description: $description
                        }
                        update: {
                            reference: $reference
                            title: $title
                            unitPrice: $unitPrice
                            vatRate: $vatRate
                            percentage: $percentage
                            type: $type
                            accountableAccount: $accountableAccountUpdate
                            stock: $stock
                            thirdPartyCompany: $thirdPartyCompanyUpdate
                            data: $data
                            tag: $tagUpdate
                            quantityType: $quantityType
                            unitQuantity: $unitQuantity
                            quantityName: $quantityName
                            description: $description
                        }
                    ) {
                        company {
                            id
                        }
                        id
                        reference
                        title
                        unitPrice
                        type
                        accountableAccount {
                            id
                        }
                        thirdPartyCompany {
                            id
                        }
                        quantityType
                        unitQuantity
                        quantityName
                    }
                }
            `,
            variables: invoiceProductVariables,
        });
        if (!this.product.id && result.data && result.data.upsertStockProduct) {
            this.product.id = result.data.upsertStockProduct.id;
        }
        this.saveLoading = false;
        this.$emit("product-saved");
        if (returnBeforeReset) {
            return;
        }
        this.resetProduct();
    }

    @Watch("id")
    onIdChanged(value) {
        if (!value) {
            this.resetProduct();
        }
    }

    @Watch("wizardStep")
    setActionButton() {
        if (this.actions && this.actions.action) {
            if (this.wizardStep === 1) {
                this.actions.action.previous = () => {
                    this.wizardStep--;
                };
            }
            if (this.wizardStep === 2) {
                this.actions.action.previous = () => {
                    this.wizardStep = 0;
                };
            }
        }
    }

    @Watch("product", { deep: true })
    onModifyProduct() {
        // debugger
        this.$emit("product", this.product);
    }

    @Watch("refExist")
    test() {
        if (this.refExist) {
            this.productReferenceRules.push(
                this.product.reference + " est déjà une référence qui existe",
            );
        } else {
            this.productReferenceRules = [];
        }
    }
}

export default toNative(CreateInvoiceProduct);
</script>

<style lang="scss" scoped>
// .v-select-font-size {
//     font-size: 12px
// }
</style>
